import { $color_grey_9, $color_grey_5, $color_grey_4, $color_brand_light_bg_default, $color_brand_light_bg_hover, $color_grey_2, $color_red_1, $color_red_2 } from '../pebbleGlobalToken/color.js';
import { $spacing_m1, $spacing_s4, $spacing_s3 } from '../pebbleGlobalToken/spacing.js';

/**
 * 按钮-颜色-文本
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_9
 */
var $button_color_text = $color_grey_9;

/**
 * 按钮-颜色-边框
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_5
 */
var $button_color_border = $color_grey_5;

/**
 * 按钮-控件高度-small
 * @description enDesc: -
 * @description type: Space
 * @description value: 28
 */
var $button_control_height_small = 28;

/**
 * 按钮-文字左右留白-large
 * @description enDesc: -
 * @description type: Space
 * @description value: 20
 */
var $button_control_padding_lg = $spacing_m1;
/**
 * 按钮-文字左右留白-middle
 * @description enDesc: -
 * @description type: Space
 * @description value: 16
 */
var $button_control_padding_md = $spacing_s4;
/**
 * 按钮-文字左右留白-small
 * @description enDesc: -
 * @description type: Space
 * @description value: 12
 */
var $button_control_padding_sm = $spacing_s3;

/**
 * 按钮-颜色-文本-禁用
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $button_color_text_disabled = $color_grey_5;

/**
 * 按钮-颜色-边框-禁用
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $button_color_border_disabled = $color_grey_4;

/**
 * 按钮-背景颜色-文本-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_default
 */
var $button_text_bg_color_hover = $color_brand_light_bg_default;

/**
 * 按钮-背景颜色-文本-active
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_hover
 */
var $button_text_bg_color_active = $color_brand_light_bg_hover;

/**
 * 按钮-颜色-次级-填充色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $button_color_fill_secondary = $color_grey_2;

/**
 * 按钮-颜色-次级-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $button_color_secondary_hover = $color_grey_4;

/**
 * 按钮-颜色-次级-active
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $button_color_secondary_active = $color_grey_5;

/**
 * 按钮-文字颜色-次级-active
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_9
 */
var $button_text_color_secondary_active = $color_grey_9;

/**
 * 按钮-颜色-危险-禁用-填充色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-red-3
 */
var $button_color_bg_error_disabled = $color_red_1;
/**
 * 按钮-颜色-危险-禁用-文字色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-red-2
 */
var $button_color_text_error_disabled = $color_red_2;

export { $button_color_bg_error_disabled, $button_color_border, $button_color_border_disabled, $button_color_fill_secondary, $button_color_secondary_active, $button_color_secondary_hover, $button_color_text, $button_color_text_disabled, $button_color_text_error_disabled, $button_control_height_small, $button_control_padding_lg, $button_control_padding_md, $button_control_padding_sm, $button_text_bg_color_active, $button_text_bg_color_hover, $button_text_color_secondary_active };
